import { useState } from "react";
import { getCurrentUserId, setTestDetail } from "../../../Backend/Auth/UserStore";

/* ── New Test Dialog ── */
export function NewTestDialog({ onConfirm, onCancel, setGlobalNotice }) {
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("");
  const [proctor, setProctor] = useState(false);

  const handleConfirm = () => {
    const uid = getCurrentUserId();
    if (!uid) {
      setGlobalNotice({
        type: "error",
        text: `Login to create test!`
      });
      return;
    }
    if (!name.trim()) return;
    setTestDetail(name.trim(), { subject: subject.trim(), proctor });
    onConfirm();
  };

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.45)",
      zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "#fff",
        borderRadius: 16,
        padding: "32px 28px",
        width: "100%", maxWidth: 400,
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        fontFamily: "'DM Sans', sans-serif",
        display: "flex", flexDirection: "column", gap: 18,
      }}>
        <p style={{ margin: 0, fontSize: 17, fontWeight: 700, color: "#202124" }}>
          New Test
        </p>

        {/* Name */}
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 12, color: "#888", fontWeight: 600 }}>TEST NAME *</label>
          <input
            autoFocus
            value={name}
            onChange={e => setName(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleConfirm()}
            placeholder="e.g. Grade 9 Physics Mid-Term"
            style={{
              fontSize: 14, padding: "10px 12px",
              border: "1.5px solid #e0e0e0", borderRadius: 8,
              outline: "none", color: "#202124",
              fontFamily: "'DM Sans', sans-serif",
            }}
          />
        </div>

        {/* Subject */}
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          <label style={{ fontSize: 12, color: "#888", fontWeight: 600 }}>SUBJECT</label>
          <input
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder="e.g. Physics, Math, English…"
            style={{
              fontSize: 14, padding: "10px 12px",
              border: "1.5px solid #e0e0e0", borderRadius: 8,
              outline: "none", color: "#202124",
              fontFamily: "'DM Sans', sans-serif",
            }}
          />
        </div>

        {/* Proctoring */}
        <div
          onClick={() => setProctor(p => !p)}
          style={{
            display: "flex", alignItems: "center", gap: 12,
            cursor: "pointer", userSelect: "none",
            padding: "10px 12px",
            borderRadius: 8,
            border: `1.5px solid ${proctor ? "#4285F4" : "#e0e0e0"}`,
            background: proctor ? "#f0f4ff" : "#fafafa",
            transition: "all 0.15s",
          }}
        >
          <div style={{
            width: 20, height: 20, borderRadius: 5, flexShrink: 0,
            border: `2px solid ${proctor ? "#4285F4" : "#bbb"}`,
            background: proctor ? "#4285F4" : "#fff",
            display: "flex", alignItems: "center", justifyContent: "center",
            transition: "all 0.15s",
          }}>
            {proctor && (
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2 6l3 3 5-5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            )}
          </div>
          <div>
            <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: "#202124" }}>
              Mandatory Proctoring
            </p>
            <p style={{ margin: 0, fontSize: 11, color: "#888" }}>
              Students will be monitored during the test
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 4 }}>
          <button
            onClick={onCancel}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "1.5px solid #e0e0e0",
              background: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
              color: "#666", fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!name.trim()}
            style={{
              padding: "9px 22px", borderRadius: 8, border: "none",
              background: name.trim() ? "#FBBC04" : "#e0e0e0",
              fontSize: 13, fontWeight: 700, cursor: name.trim() ? "pointer" : "default",
              color: name.trim() ? "#fff" : "#aaa",
              fontFamily: "'DM Sans', sans-serif",
              transition: "background 0.15s",
            }}
          >
            Create
          </button>
        </div>
      </div>
    </div>
  );
}
